var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/directives/repeat.js", "lit/directives/class-map.js", "lit/decorators.js", "@lit/context", "./app-context", "underscore", "./chat-message", "./chat-userinput", "./app", "./custom-element-registry", "utils/resizer", "./utils/theme", "../../../apps/src/js/api/v2/models/answer", "./utils", "i18n/i18n"], function (require, exports, lit_1, repeat_js_1, class_map_js_1, decorators_js_1, context_1, app_context_1, _, chat_message_1, chat_userinput_1, app_1, custom_element_registry_1, resizer_1, theme_1, answer_1, utils_1, i18n_1) {
    "use strict";
    var _a, _b, _c, _d, _e, _f;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ChatElement = exports.ChatActionsElement = exports.ChatViewElement = exports.booleanAttributeConverter = void 0;
    exports.booleanProperty = booleanProperty;
    _ = __importStar(_);
    resizer_1 = __importDefault(resizer_1);
    i18n_1 = __importDefault(i18n_1);
    function getDefaultChannel(application) {
        return application.channels.at(0);
    }
    function getDefaulChannelBaseUrl(application) {
        return application.channels.at(0).get("url") + "../../api/chat/v1beta";
    }
    exports.booleanAttributeConverter = {
        fromAttribute: (value) => value === 'true',
        toAttribute: (value) => (value ? 'true' : 'false'),
    };
    function booleanProperty(options = {}) {
        return (0, decorators_js_1.property)(Object.assign({ type: Boolean, converter: exports.booleanAttributeConverter }, options));
    }
    class ChatViewElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.messagesHeight = 0;
        }
        static get styles() {
            // TODO import other variables from the theme descriptior
            //      also theme variables should be prefixed? e.g. mb-color-...
            return (0, lit_1.css) `
          :host {
             color: var(--mindbreeze-colors-primary);
             display: flex;
             flex-direction: column;
             height: 100vh;
          }

          .actions {
            position: relative;
          }

          .messages-scroll {
            flex: 1;
            min-height:10%;
            overflow: auto;
            display:flex;
          	-webkit-overflow-scrolling: touch;
            scroll-behavior: smooth;
          }

          .messages {
            display: flex;
            flex-direction: column;
            flex-grow:1;
            min-height: 100%;
            /* background: #eee; */
            min-width: 0;
            flex-shrink: 1;
          }
          .wrapper {
             display:flex;
             flex-direction: column;
             position: relative;
             height: 100%;
             width: 100%;          
             top: 0;
             left: 0;
          }
          .scroll-wrapper {
             position: absolute;
             scrollbar-width: thin;
             height: 100%;
             top: 0;
             left: 0;
             overflow-y: auto;
          }
          .input {
          }

          * {
            scrollbar-width: thin;
          }
          .view{
            height:100% !important;
            display: flex;
            flex-direction: column;
            overflow:hidden;
          }
          .view .messages-scroll{
            flex-grow: 1;
          }

          
    `;
        }
        render() {
            return (0, lit_1.html) `
        <div class="view">
          <div class="actions"><slot name="actions"></slot></div>              
            <div class="space"></div>
            <div class="messages-scroll">
                <div class="messages">
                    <slot name="messages"></slot>
                </div>
            </div>
            <div class="input">
                <slot name="input"></slot>
            </div>
        </div>
    `;
        }
    }
    exports.ChatViewElement = ChatViewElement;
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Object)
    ], ChatViewElement.prototype, "messagesHeight", void 0);
    class ChatActionsElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.displayCreateConv = true;
            this.createConvBtnHovered = false;
        }
        static get styles() {
            return (0, lit_1.css) `
    :host(.chat-action-container.full-width) {
      position: sticky;
      top: 0;
      width: 100%;
      background: white;
      top: 0;
      left: 0;
    }
    :host(.chat-action-container) {
      display: flex;
      flex-direction : row;
      gap: 8px;
      width: fit-content;
      min-width: 0px;
      align-items: center;
      position: absolute;
      top: 15px;
      left: 15px;
      z-index: 1;
    }

    :host(.chat-action-container) .action-item {
      display: flex;
      align-items: center;
    }

    .actions .btn-link {
      padding: 8px;
      color: #898888;
      cursor: pointer;
      background-color: var(--insight-chat-actions-button-passive-color);
      border: 1px solid var(--insight-chat-actions-button-border-color);
      border-radius:50%;
    }
    .actions .btn-link:hover,
    .actions .btn-link:active {
      background-color: var(--insight-chat-actions-button-clicked-color);
    }
    :host(.chat-action-container.full-width) .actions .btn-link {
      background-color: transparent;
      border: none;
    }

    .actions .reset-chat-btn-tooltip {
      display: none;
      font-weight: bold;
    }
    :host(.chat-action-container.full-width) .actions .reset-chat-btn-tooltip {
      display: inline;
      white-space: nowrap;
      line-height: 23px;
    }
    :host(.chat-action-container:not(.full-width)) .actions .action-item.button-hovered .reset-chat-btn-tooltip {
      display: inline;
      white-space: nowrap;
      color: var(--mindbreeze-colors-on-surface-container);
      background-color: var(--mindbreeze-colors-surface-container);
      border-radius: 10px;
      border: none;
      padding: 2px 12px 2px 12px;
      font-size: 12px;
      margin-left: 8px;
    }

    .actions a {
      text-decoration: none;
      font-weight: bold;
      color: var(--result-actions-color);
      cursor: pointer;
      font-family: var(--result-actions-font-family);
      font-size: var(--result-actions-font-size);
      font-weight: var(--result-actions-font-weight)
    }
    .actions .mb-icon  {
      height: 16px;
      width: 16px;
    }
  `;
        }
        onResetChat() {
            console.log("reset");
        }
        render() {
            var _a, _b, _c;
            const theme = this.themeDescriptor || {};
            const icons = theme.icons || {};
            const fontColor = (0, theme_1.resolveCssVarValue)((_c = (_b = (_a = theme.themes) === null || _a === void 0 ? void 0 : _a.base) === null || _b === void 0 ? void 0 : _b.colors) === null || _c === void 0 ? void 0 : _c.outline, theme) || 'currentColor';
            const createNewIcon = (0, utils_1.renderIcon)(icons, 'pen-to-square', {
                color: fontColor,
                altText: (0, i18n_1.default)('create_new_conversation'),
            });
            let actions = [];
            if (this.displayCreateConv) {
                actions.push((0, lit_1.html) `
        <div class="action-item ${this.createConvBtnHovered ? "button-hovered" : ""}">
          <button @click=${this.startNewConversation} 
            class="btn btn-link mb-action-reset-chat-conversation"
            @mouseenter=${this._onCreateConvBtnEnter}
            @mouseleave=${this._onCreateConvBtnLeave}
          >
            ${createNewIcon}<span class="mb-acc"></span>
          </button>
                                        <!-- TODO: add translation -->
          <label class="reset-chat-btn-tooltip" @click=${this.startNewConversation}>${(0, i18n_1.default)('start_new_conversation')}</label> 
        </div>
        `);
            }
            return (0, lit_1.html) `<div class="actions">
          ${actions}
      </div>`;
        }
        startNewConversation() {
            this.createConvBtnHovered = false;
            this.dispatchEvent(new CustomEvent('action', {
                bubbles: true,
                composed: true,
                detail: { action: "createNewConversation" }
            }));
        }
        _onCreateConvBtnEnter() {
            this.createConvBtnHovered = true;
        }
        _onCreateConvBtnLeave() {
            this.createConvBtnHovered = false;
        }
    }
    exports.ChatActionsElement = ChatActionsElement;
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_a = typeof Partial !== "undefined" && Partial) === "function" ? _a : Object)
    ], ChatActionsElement.prototype, "themeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_b = typeof Partial !== "undefined" && Partial) === "function" ? _b : Object)
    ], ChatActionsElement.prototype, "chatWidgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Boolean)
    ], ChatActionsElement.prototype, "displayCreateConv", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Boolean)
    ], ChatActionsElement.prototype, "createConvBtnHovered", void 0);
    class ChatElement extends lit_1.LitElement {
        static get styles() {
            // TODO import other variables from the theme descriptior
            //      also theme variables should be prefixed? e.g. mb-color-...
            return (0, lit_1.css) `
      :host {
        color: var(--mindbreeze-colors-primary);
      }
      h1 {
        color: var(--color-link);
      }
      .chat {
        display:grid;
        height: 100%;
      }
          
    `;
        }
        constructor() {
            super();
            this.isStreaming = false;
            this.conversation = [];
            this.autoScroll = true;
            this.enableCitation = true;
            this.useSearchInput = true;
            this.useUserConstraints = true;
            this.useSourceContextConstraints = true;
            this.initializeFromUserQuery = false;
            this.applyAnswersSettings = true;
            this.showCreateNewConversation = true;
            this.messagesFrameHeight = 0;
            this.showScrollButton = false;
            // Template callbacks
            this.onViewCreate = (modelHolder, options) => {
                // console.log("onViewCreate", options);
                if (!this.application) {
                    this.application = options.application || modelHolder.options.application;
                }
                this.setModel(modelHolder.model);
                this.settingsConfig = options === null || options === void 0 ? void 0 : options.settingsConfig;
                if (this.application) {
                    // @ts-ignore
                    this.chatStylingModel = this.application.getThemeProvider().getWidgetStyling("chat");
                    if (this.chatStylingModel) {
                        this.chatStylingModel.on('change', () => {
                            this.widgetStyling = Object.assign({}, this.chatStylingModel.attributes);
                        });
                        this.chatStylingModel.trigger('change');
                    }
                }
                // In workplace the `chatViewEl` is not in dom yet so that the resize handler is not attached to window
                this.attachResizeHandler();
                if (this.initialUserInput || this.initializeFromUserQuery) {
                    const initialUserInput = this.initialUserInput;
                    this.application.execute((app) => {
                        const input = this.querySelector("insight-chat-input");
                        const userQuery = app.getUnparsedUserQuery();
                        if (input === null || input === void 0 ? void 0 : input.submitText) {
                            if (initialUserInput) {
                                input.submitText(initialUserInput);
                            }
                            else if (userQuery) {
                                input.submitText(userQuery);
                            }
                        }
                    });
                }
            };
            this.onViewRemove = () => {
                console.log("onViewRemove");
                this.chatStylingModel.destroy();
            };
            this.handleStopGenerating = this.handleStopGenerating.bind(this);
        }
        setModel(model) {
            this.model = model;
        }
        attachResizeHandler() {
            var _a, _b;
            const chatViewEl = this.querySelector("insight-chat-view");
            if (chatViewEl && chatViewEl.shadowRoot) {
                const viewportElement = ((_b = (_a = this.application) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.viewportElement) || this.parentElement;
                this.resizer = new resizer_1.default(chatViewEl, viewportElement, { height: this.height });
                //insight-chat has negative offset
                this.resizer.resize();
                const handleOnResize = () => {
                    this.resizer.resize();
                };
                window.addEventListener("resize", handleOnResize);
                this.scrollContainer = chatViewEl.querySelector('[slot="messages"]');
                if (this.scrollContainer) {
                    this.scrollContainer.addEventListener("scroll", () => {
                        const isAtBottom = this.scrollContainer.scrollTop + this.scrollContainer.clientHeight >=
                            this.scrollContainer.scrollHeight - 2;
                        this.showScrollButton = !isAtBottom;
                    });
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            var _a;
            this.themeDescriptorModel = themeDescriptorModel;
            if (this.themeDescriptorModel && this.application) {
                this.themeDescriptor = (_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes;
                this.themeDescriptorModel.on("change", () => {
                    var _a;
                    this.themeDescriptor = (_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes;
                    this.requestUpdate();
                });
            }
        }
        getConversationMessages() {
            var _a, _b, _c, _d;
            let messages = [];
            for (let pair of this.conversation) {
                if (pair.user) {
                    messages.push({
                        from: "user",
                        content: pair.user.text,
                    });
                }
                if (pair.assistant) {
                    const text = ((_b = (_a = pair.assistant.models) === null || _a === void 0 ? void 0 : _a.answer) === null || _b === void 0 ? void 0 : _b.get("unparsed_generated_text_without_citations")) || ((_d = (_c = pair.assistant.models) === null || _c === void 0 ? void 0 : _c.answer) === null || _d === void 0 ? void 0 : _d.get("unparsed_generated_text"));
                    messages.push({
                        from: "assistant",
                        content: text !== null && text !== void 0 ? text : "",
                    });
                }
            }
            return messages;
        }
        requestUpdate(name, oldValue, options) {
            if (name == "application" && oldValue == null && this.application) {
                // console.log("application available, wiring theme descriptor");
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
            super.requestUpdate(name, oldValue, options);
        }
        forceFocusonInput() {
            return this.themeDescriptor.widgets.chat.input.textInput.forceFocus;
        }
        getPipelineSelection(selection, value) {
            let result = {};
            result["pipeline_" + selection] = value;
            return result;
        }
        getBaseGenerateInput() {
            let baseSettings = {};
            if (this.applyAnswersSettings) {
                const answersSettings = this.settingsConfig.getEffectiveSettingsForTemplate("answers", {});
                if (answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.conversationInputPresetsJson) {
                    let presetsJson = answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.conversationInputPresetsJson;
                    if (typeof presetsJson === "string") {
                        try {
                            presetsJson = JSON.parse(presetsJson);
                        }
                        catch (e) {
                            console.warn("Failed to parse presets", e);
                        }
                    }
                    if (typeof presetsJson !== "object") {
                        console.warn("Failed to apply presetsJson, expected object-obtained", typeof presetsJson);
                    }
                    else {
                        baseSettings = Object.assign({}, presetsJson);
                    }
                }
                if ((answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelection) && (answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelectionValue)) {
                    baseSettings = Object.assign(baseSettings, this.getPipelineSelection(answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelection, answersSettings === null || answersSettings === void 0 ? void 0 : answersSettings.pipelineSelectionValue));
                    return baseSettings;
                }
            }
            if (this.pipelineSelection && this.pipelineSelectionValue) {
                baseSettings = Object.assign(baseSettings, this.getPipelineSelection(this.pipelineSelection, this.pipelineSelectionValue));
            }
            else if (this.modelId) {
                baseSettings = Object.assign(baseSettings, this.getPipelineSelection("id", this.modelId));
            }
            return baseSettings;
        }
        generateFromInput(event) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                this.isStreaming = true;
                const text = event.detail.text;
                event.preventDefault();
                // console.log("input changes", text);
                const defaultChannel = getDefaultChannel(this.application);
                const url = defaultChannel.get("url");
                const channelOptions = Object.assign({}, this.application.channelOptions || {});
                channelOptions.application = this.application;
                const citationIdPrefix = _.uniqueId("cit");
                const messages = this.getConversationMessages();
                const channelInfo = { url,
                    channelOptions,
                    prepareRequest: defaultChannel.prepareRequest.bind(defaultChannel) };
                // TOOD get PipelineSelection as an option
                const searchModelOptions = {
                    useSearchInput: this.useSearchInput,
                    useUserConstraints: this.useUserConstraints,
                    useSourceContextConstraints: this.useSourceContextConstraints
                };
                const createRAGPipelineAnswerInputAttributes = this.getBaseGenerateInput();
                this.answerModel = (0, answer_1.createRAGPipelineAnswerModel)(Object.assign(Object.assign({}, createRAGPipelineAnswerInputAttributes), {
                    inputs: text,
                    messages: messages,
                    stream: true,
                    retrieval_options: {
                        skip_retrieval: false,
                        search_request: {} // this shoud be filled in later.
                    },
                    // generation_options: {
                    //    message_templates: messages
                    //},
                    parameters: {
                        retrieval_details: true,
                    },
                    //TBD: passing settings while create application is too late and
                    // config should be loaded from appfragment schema 
                    // we should also distinguish between ai-answer in standalone mode and chat mode
                    citation_options: {
                        enable_citation: this.enableCitation,
                        citationid_prefix: citationIdPrefix
                    }
                }), { application: this.application, channelInfo }, null, answer_1.SearchModelTriggerStrategyType.None, searchModelOptions);
                this.answerModel.deactivate();
                this.answerModel.on("regenerate-answer", this.handleRegenerateAnswerEvent.bind(this));
                this.answerModel.on("stop-generate-answer", this.handleStopGenerateAnswerEvent.bind(this));
                this.answerModel.on("computed", () => {
                    // console.log("Answer computed");
                    this.isStreaming = false;
                });
                this.answerModel.on("computing", () => {
                    this.isStreaming = true;
                });
                const user = {
                    kind: "user",
                    id: this.conversation.length,
                    text: text,
                };
                const assistant = {
                    kind: "assistant",
                    id: this.conversation.length + 1,
                    name: "assistant",
                    type: "basic",
                    models: { answer: this.answerModel },
                    modelDefaults: {
                        search: Object.assign({}, ((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.attributes) || {})
                    },
                    messages,
                    initializedCallback: (app) => {
                        if (this.answerModel.searchModel) {
                            this.answerModel.searchModel.deactivate();
                        }
                        this.answerModel.activate();
                    }
                };
                // Triggers rerender
                this.conversation = [...this.conversation, { user, assistant }];
            });
        }
        updated(changedProps) {
            super.updated(changedProps);
            requestAnimationFrame(() => {
                var _a;
                const chatViewEl = this.querySelector("insight-chat-view");
                const messagesScroll = (_a = chatViewEl.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.messages-scroll');
                if (messagesScroll) {
                    this.messagesFrameHeight = messagesScroll.offsetHeight;
                    this.style.setProperty('--messages-frame-height', `${this.messagesFrameHeight}px`);
                }
            });
            if (changedProps.has("conversation")) {
                requestAnimationFrame(() => {
                    const container = this.renderRoot.querySelector('[slot="messages"]');
                    if (!container)
                        return;
                    const messages = container.querySelectorAll("insight-chat-message");
                    if (messages.length === 0)
                        return;
                    const lastMessage = messages[messages.length - 1];
                    const targetScrollTop = lastMessage.offsetTop;
                    container.scrollTo({
                        top: targetScrollTop,
                        behavior: "smooth"
                    });
                    // cleanup last Observer
                    if (this.observer) {
                        this.observer.disconnect();
                        this.observer = null;
                    }
                    // create new Observer
                    this.observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (this.conversation.length) {
                                this.showScrollButton = !entry.isIntersecting;
                            }
                            else {
                                this.showScrollButton = false;
                            }
                        });
                    }, { root: container, threshold: 0.1 });
                    this.observer.observe(lastMessage);
                });
            }
        }
        onChatAction(event) {
            var _a;
            if (event.detail.action == "createNewConversation") {
                (_a = this.answerModel) === null || _a === void 0 ? void 0 : _a.abortComputation();
                this.conversation = [];
                let input = this.querySelector("insight-chat-input");
                input.focusTextArea();
            }
        }
        handleStopGenerateAnswerEvent(answerModel) {
            this.answerModel.abortComputation();
            this.isStreaming = false;
        }
        handleRegenerateAnswerEvent(answerModel, app) {
            var _a;
            const conversationChatFoundIdx = this.conversation.findIndex((pair) => { var _a, _b, _c; return ((_c = (_b = (_a = pair === null || pair === void 0 ? void 0 : pair.assistant) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.answer) === null || _c === void 0 ? void 0 : _c.cid) === answerModel.cid; });
            if (conversationChatFoundIdx !== -1) {
                const { user } = this.conversation[conversationChatFoundIdx];
                if (user) {
                    // Get only the lsit of messages before current message
                    const messages = (_a = this.getConversationMessages()) === null || _a === void 0 ? void 0 : _a.slice(0, conversationChatFoundIdx);
                    // TODO
                    // this.generateTextStream(answerModel, user.text, messages, app);
                }
                else {
                    console.error("Failed to regenerate the answer, no user part found.");
                }
            }
            else {
                console.error("Failed to regenerate the answer, no assistent part found.");
            }
        }
        createRenderRoot() {
            return this;
        }
        assistantAppSettings() {
            var _a, _b, _c;
            return {
                "initAction": {
                    settings: {
                        "answers.enableCitation": this.enableCitation,
                        "answers.metadatakeys": this.metadatakeys,
                        "answers.lineLimit": (_c = (_b = (_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.base) === null || _c === void 0 ? void 0 : _c.maxLines,
                        "answers.showQuestion": false
                    }
                },
            };
        }
        renderPart(part) {
            var _a, _b, _c, _d;
            // TODO: should we pass icons prop to the insight-chat-message and remove themeDescriptor?
            // const chatTheme = this.themeDescriptor.widgets.chat;
            const chatTheme = this.widgetStyling;
            if (part.kind === "assistant") {
                const appFragmentJson = {
                    name: "chatmessage",
                    type: "assistant",
                    htmlFragment: `<div data-template="answers" data-answer-model="answer"></div>`
                };
                const effectiveSettings = this.assistantAppSettings();
                return (0, lit_1.html) `
        <insight-chat-message role="assistant" .themeDescriptor=${this.themeDescriptor} .messageThemeDescriptor=${(_a = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _a === void 0 ? void 0 : _a['assistant']} .baseMessageThemeDescriptor=${(_b = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _b === void 0 ? void 0 : _b['base']}>
          <insight-app
              .appFragmentJson=${appFragmentJson}
              .settings=${effectiveSettings}
              .models=${Object.assign({}, part.models)}
              .modelDefaults=${part.modelDefaults}
              .initializedCallback=${part.initializedCallback}
          ></insight-app>
        </insight-chat-message>
      `;
            }
            else if (part.kind === "user") {
                return (0, lit_1.html) `
        <insight-chat-message role="user" .themeDescriptor=${this.themeDescriptor} .messageThemeDescriptor=${(_c = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _c === void 0 ? void 0 : _c['user']} .baseMessageThemeDescriptor=${(_d = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.message) === null || _d === void 0 ? void 0 : _d['base']}>
          <div style="white-space: break-spaces;">${part.text}</div>
        </insight-chat-message>
      `;
            }
        }
        // TODO register this per widget so that the application can render that once.
        renderVariables() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11;
            if (!((_b = (_a = this.themeDescriptor) === null || _a === void 0 ? void 0 : _a.widgets) === null || _b === void 0 ? void 0 : _b.chat)) {
                return "";
            }
            // 
            const ApplicationPrefix = (_c = this.application.themeable.prefix) !== null && _c !== void 0 ? _c : '';
            const prefix = "";
            const chatTheme = (_d = this.widgetStyling) !== null && _d !== void 0 ? _d : (_f = (_e = this.themeDescriptor) === null || _e === void 0 ? void 0 : _e.widgets) === null || _f === void 0 ? void 0 : _f.chat;
            const assistantBackground = (chatTheme) => {
                var _a, _b, _c, _d;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.assistant) === null || _a === void 0 ? void 0 : _a.backgroundColor) || ((_b = chatTheme.message.assistant) === null || _b === void 0 ? void 0 : _b.background) || ((_c = chatTheme.message.base) === null || _c === void 0 ? void 0 : _c.backgroundColor) || ((_d = chatTheme.message.base) === null || _d === void 0 ? void 0 : _d.background));
            };
            const userInputBackground = (chatTheme) => {
                var _a, _b, _c, _d;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_b = (_a = chatTheme.input) === null || _a === void 0 ? void 0 : _a.textInput) === null || _b === void 0 ? void 0 : _b.backgroundColor) || ((_d = (_c = chatTheme.input) === null || _c === void 0 ? void 0 : _c.textInput) === null || _d === void 0 ? void 0 : _d.background));
            };
            const userBackground = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.user) === null || _a === void 0 ? void 0 : _a.backgroundColor) || ((_b = chatTheme.message.user) === null || _b === void 0 ? void 0 : _b.background));
            };
            const assistantFontFamily = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.assistant) === null || _a === void 0 ? void 0 : _a.fontFamily) || ((_b = chatTheme.message.base) === null || _b === void 0 ? void 0 : _b.fontFamily));
            };
            const userFontFamily = (chatTheme) => {
                var _a, _b;
                return (0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, ((_a = chatTheme.message.user) === null || _a === void 0 ? void 0 : _a.fontFamily) || ((_b = chatTheme.message.base) === null || _b === void 0 ? void 0 : _b.fontFamily));
            };
            return (0, lit_1.html) `
        <style>
           /** The accessibility.js inject this css class to body on input focus, to avoid setting unwanted focus style we override*/
           .mb-highlight-focus insight-chat-input:focus {
              box-shadow: none !important;
              outline: none !important;
              -webkit-box-shadow: none !important;
           }
           insight-chat {
            --insight-chat-message-gap: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_h = (_g = chatTheme.message) === null || _g === void 0 ? void 0 : _g.base) === null || _h === void 0 ? void 0 : _h.messageGap)};
            --insight-chat-message-citation-link-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_l = (_k = (_j = chatTheme.message.base) === null || _j === void 0 ? void 0 : _j.citation) === null || _k === void 0 ? void 0 : _k.link) === null || _l === void 0 ? void 0 : _l.color)};
            --insight-chat-header-padding: ${chatTheme.header.isFullWidth ? chatTheme.header.paddingTop : 0}
           }
           insight-chat-actions {
            --insight-chat-actions-button-passive-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.passiveColor)};
            --insight-chat-actions-button-clicked-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.clickedColor)};
            --insight-chat-actions-button-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.header.action.border.color)};
           }
           insight-chat-message[role=user] {
            --insight-chat-message-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.color)};
            --insight-chat-message-avatar-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarColor)}; 
            --insight-chat-message-background: ${userBackground(chatTheme)};
            /** TBD this values for user-message border properties are not falling back to base  */
            --insight-chat-message-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderWidth)};
            --insight-chat-message-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderColor)};
            --insight-chat-message-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderStyle)};
            --insight-chat-message-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.borderRadius)};
            --insight-chat-message-avatar-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarWidth)};
            --insight-chat-message-avatar-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.avatarHeight)};
            --insight-chat-message-font-family: ${userFontFamily(chatTheme)};
            --insight-chat-message-bubble-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.maxBubbleWidth)};
            --insight-chat-message-bubble-min-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.minBubbleWidth)};
            --insight-chat-message-bubble-padding: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.user.bubblePadding)};
           }

           insight-chat-message[role=assistant] {
            --insight-chat-message-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.color)};
            --insight-chat-message-avatar-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarColor)};
            --insight-chat-message-background: ${assistantBackground(chatTheme)};
            --insight-chat-message-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderWidth)};
            --insight-chat-message-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderColor)};
            --insight-chat-message-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderStyle)};
            --insight-chat-message-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.borderRadius)};
            --insight-chat-message-font-family: ${assistantFontFamily(chatTheme)};
            --insight-chat-message-bubble-padding: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.bubblePadding)};
            --insight-chat-message-bubble-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.maxBubbleWidth)};
            --insight-chat-message-bubble-min-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.minBubbleWidth)};
            ${chatTheme.message.assistant.avatarWidth && `--insight-chat-message-avatar-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarWidth)};`};
            ${chatTheme.message.assistant.avatarHeight && `--insight-chat-message-avatar-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.message.assistant.avatarHeight)};`};
           }

           insight-chat-input {
            --insight-chat-input-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_o = (_m = chatTheme.input) === null || _m === void 0 ? void 0 : _m.textInput) === null || _o === void 0 ? void 0 : _o.color)};
            --insight-chat-input-background: ${userInputBackground(chatTheme)};
            --insight-chat-input-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_q = (_p = chatTheme.input) === null || _p === void 0 ? void 0 : _p.textInput) === null || _q === void 0 ? void 0 : _q.borderRadius)};
            --insight-chat-input-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_s = (_r = chatTheme.input) === null || _r === void 0 ? void 0 : _r.textInput) === null || _s === void 0 ? void 0 : _s.fontFamily)};
            --insight-chat-input-max-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_u = (_t = chatTheme.input) === null || _t === void 0 ? void 0 : _t.textInput) === null || _u === void 0 ? void 0 : _u.maxInputWidth)};
            --insight-chat-input-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_x = (_w = (_v = chatTheme.input) === null || _v === void 0 ? void 0 : _v.textInput) === null || _w === void 0 ? void 0 : _w.border) === null || _x === void 0 ? void 0 : _x.width)};
            --insight-chat-input-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_0 = (_z = (_y = chatTheme.input) === null || _y === void 0 ? void 0 : _y.textInput) === null || _z === void 0 ? void 0 : _z.border) === null || _0 === void 0 ? void 0 : _0.color)};
            --insight-chat-input-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_3 = (_2 = (_1 = chatTheme.input) === null || _1 === void 0 ? void 0 : _1.textInput) === null || _2 === void 0 ? void 0 : _2.border) === null || _3 === void 0 ? void 0 : _3.style)};
            ${((_5 = (_4 = chatTheme.input) === null || _4 === void 0 ? void 0 : _4.textInput) === null || _5 === void 0 ? void 0 : _5.border)
                ? `
                  --insight-chat-input-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.color)};
                  --insight-chat-input-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.width)};
                  --insight-chat-input-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.border.style)};
                `
                : ''};
            ${((_7 = (_6 = chatTheme.input) === null || _6 === void 0 ? void 0 : _6.textInput) === null || _7 === void 0 ? void 0 : _7.focus) && ((_9 = (_8 = chatTheme.input) === null || _8 === void 0 ? void 0 : _8.textInput) === null || _9 === void 0 ? void 0 : _9.focus.border)
                ? `
                  --insight-chat-input-border-focus-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.color)};
                  --insight-chat-input-border-focus-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.width)};
                  --insight-chat-input-border-focus-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, chatTheme.input.textInput.focus.border.style)};
                `
                : ''};
            --insight-chat-input-boxshadow: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_11 = (_10 = chatTheme.input) === null || _10 === void 0 ? void 0 : _10.textInput) === null || _11 === void 0 ? void 0 : _11.boxShadow)};
           }
           insight-app {
              display: block;
              min-width: 0;
              max-width: 100%;
           }
           insight-app > .mb-flexbox{
              flex-grow:1;
           }
           insight-app code{
            white-space: normal;
            color:var(--insight-chat-message-color);
           }
           insight-chat {
             position: relative;
           }
          insight-chat-view .mb-answers-container .mb-answer-header {
            display:none;
          }
          insight-chat-view .mb-answers-container .mb-answer-item {
            border: none !important;
          }
        
          insight-chat-view .mb-answers-container .mb-action-stop-generating,
          insight-chat-view.isStreaming .mb-answers-container .mb-action-regenerate-answer{
            display:none !important;
          }

          insight-chat-view .mb-answers-container .mb-answer{
            padding:16px 20px;
          }
          insight-chat-view .mb-answers-container .generated-answer-text,
          insight-chat-view .mb-answers-container .mb-answer-item:first-child .mb-answer
          {
            padding:0;
          }
          insight-chat-view .mb-answers-container a[href^="#block-citation-id="]{
            color: var(--insight-chat-message-citation-link-color);
          }
          insight-chat-view .mb-answers-container{
            background: var(--message-background) !important;;
            border-radius: var(--message-border-radius) !important;;
            border-width: var(--message-border-width) !important;;
            border-color: var(--message-border-color) !important;;
            border-style: var(--message-border-style) !important;;
            font-family:  var(--message-font-family) !important;;
            margin:0 !important;
            max-width: unset!important;;
            border-left: ${!chatTheme.message.assistant.hideLeftAccentBorder ? `3px solid var(--${ApplicationPrefix ? `${ApplicationPrefix}-` : ''}colors-secondary)` : "none"} !important;
          }
            .message-list{
              display:flex; 
              flex-direction: column;
              margin-bottom:10px;
              scrollbar-gutter: stable;
              flex-grow:1;
              overflow-y: auto;
            }

            /* width */
            .message-list::-webkit-scrollbar {
              width: 5px;
            }

            /* Track */
            .message-list::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius:10px;
            }

            /* Handle */
            .message-list::-webkit-scrollbar-thumb {
              background: #888;
            }

            .qa-wrapper{
              display: flex;
              flex-direction: column;
              gap: var(--insight-chat-message-gap);
              padding:10px;
            }
            .qa-wrapper:last-child{
              ${chatTheme.showMessageOnTop ? `min-height:calc(var(--messages-frame-height) - 30px);` : "auto"};
            }
          .scroll-bottom{
            width:40px;
            height:40px;
            border-radius:50%;
            border:none;
            position: absolute; 
            bottom: 60px; 
            right: 20px;
            display:flex;
            justify-content: center;
            align-items: center;
            padding: 0;
          }
          .scroll-bottom .mb-icon {
            width:100%;
            height: auto;
          }
        </style>
    `;
        }
        renderTurn(turn) {
            return (0, lit_1.html) `
      <div class="qa-wrapper">
        ${this.renderPart(turn.user)}
        ${this.renderPart(turn.assistant)}
      </div>
    `;
        }
        handleStopGenerating() {
            this === null || this === void 0 ? void 0 : this.answerModel.trigger('stop-generate-answer', this === null || this === void 0 ? void 0 : this.answerModel);
        }
        renderScrollToBottomIcon() {
            const key = 'scroll-to-bottom-icon';
            const icons = this.themeDescriptor['icons'];
            return (0, utils_1.renderIcon)(icons, key, { altText: (0, i18n_1.default)('icon') });
        }
        render() {
            var _a, _b, _c;
            //TODO: Selecting Modes
            const chatTheme = this.widgetStyling;
            const showScrollToBottom = (_a = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.showScrollToBottom) !== null && _a !== void 0 ? _a : false;
            const isFullWidth = (_b = chatTheme === null || chatTheme === void 0 ? void 0 : chatTheme.header) === null || _b === void 0 ? void 0 : _b.isFullWidth;
            return (0, lit_1.html) `
      ${this.renderVariables()}
      <insight-chat-view class=${this.isStreaming ? "isStreaming" : ""}>
      <div slot="actions">
        <insight-chat-actions 
          class="${(0, class_map_js_1.classMap)({ "chat-action-container": true, "full-width": isFullWidth })}" 
          @action=${this.onChatAction} 
          .displayCreateConv=${!(((_c = this.conversation) === null || _c === void 0 ? void 0 : _c.length) == 0) && this.showCreateNewConversation} 
          .themeDescriptor=${this.themeDescriptor} 
          .chatWidgetStyling=${chatTheme}
        >
        </insight-chat-actions>
      </div>
      <div slot="messages" class="message-list">
      ${(0, repeat_js_1.repeat)(this.conversation, (part) => part.user.id, (part) => this.renderTurn(part))}
      </div>
      <div slot="input">
        <insight-chat-input
          @userinput=${this.generateFromInput}
          .isStreaming=${this.isStreaming}
          .forceFocus=${this.forceFocusonInput}
          .icons=${this.themeDescriptor['icons']}
          .handleStopGenerating = ${this.handleStopGenerating}
        ></insight-chat-input>
         ${this.showScrollButton && showScrollToBottom
                ? (0, lit_1.html) `<button
            class="scroll-bottom"
            @click=${() => {
                    const container = this.querySelector('[slot="messages"]');
                    if (container)
                        container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
                }}
          >
            ${this.renderScrollToBottomIcon()}
          </button>`
                : null}
      </div>
      </insight-chat-view>
     
    `;
        }
    }
    exports.ChatElement = ChatElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_c = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _c : Object)
    ], ChatElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_d = typeof Partial !== "undefined" && Partial) === "function" ? _d : Object)
    ], ChatElement.prototype, "themeDescriptor", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "isStreaming", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "conversation", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_e = typeof Partial !== "undefined" && Partial) === "function" ? _e : Object)
    ], ChatElement.prototype, "widgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "autoScroll", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Number)
    ], ChatElement.prototype, "maxLines", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "modelid" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "modelId", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "height" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "height", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "pipeline-selection" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "pipelineSelection", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "pipeline-selection-value" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "pipelineSelectionValue", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "metadatakeys" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "metadatakeys", void 0);
    __decorate([
        booleanProperty({ attribute: "enable-citation" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "enableCitation", void 0);
    __decorate([
        booleanProperty({ attribute: "use-search-input" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useSearchInput", void 0);
    __decorate([
        booleanProperty({ attribute: "use-user-constraints" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useUserConstraints", void 0);
    __decorate([
        booleanProperty({ attribute: "use-source-context-constraints" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "useSourceContextConstraints", void 0);
    __decorate([
        booleanProperty({ attribute: "initialize-from-user-query" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "initializeFromUserQuery", void 0);
    __decorate([
        booleanProperty({ attribute: "apply-answers-settings" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "applyAnswersSettings", void 0);
    __decorate([
        booleanProperty({ attribute: "show-create-new-conversation" }),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "showCreateNewConversation", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: "initial-user-input" }),
        __metadata("design:type", String)
    ], ChatElement.prototype, "initialUserInput", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Number }),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "messagesFrameHeight", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_f = typeof ComputedModel !== "undefined" && ComputedModel) === "function" ? _f : Object)
    ], ChatElement.prototype, "model", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], ChatElement.prototype, "showScrollButton", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "onViewCreate", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ChatElement.prototype, "onViewRemove", void 0);
    // TODO check if this is already the case.
    custom_element_registry_1.customElementRegistry.register("insight-chat", ChatElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-view", ChatViewElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-input", chat_userinput_1.ChatInputElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-actions", ChatActionsElement);
    custom_element_registry_1.customElementRegistry.register("insight-app", app_1.AppElement);
    custom_element_registry_1.customElementRegistry.register("insight-chat-message", chat_message_1.InsightChatMessage);
});
